<mat-drawer-container autosize style="background: white">

    <mat-drawer #drawer [mode]="'side'" position="end">
        <div class="container">
            <h3 class="padding-top-15">Filters</h3>
            <mat-divider></mat-divider>
            <mat-form-field class="padding-top-15">
                <mat-label>Location</mat-label>
                <mat-select [(ngModel)]="filters.location.value" (selectionChange)="updateFilter()">
                    <mat-option value="">All locations</mat-option>
                    <mat-option *ngFor="let location of filters.location.options"
                                [value]="location.vetSourceId">{{location.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-divider></mat-divider>
            <mat-form-field class="padding-top-15">
                <mat-label>Status</mat-label>
                <mat-select [(ngModel)]="filters.status.value" (selectionChange)="updateFilter()">
                    <mat-option value="">All statuses</mat-option>
                    <mat-option value="POSTED">POSTED</mat-option>
                    <mat-option value="ERROR_POSTING">ERROR_POSTING</mat-option>
                    <mat-option value="SKIPPED_POSTING">SKIPPED_POSTING</mat-option>
                    <mat-option value="DELETED">DELETED</mat-option>
                </mat-select>
            </mat-form-field>
            <br/>
            <button (click)="drawer.toggle()" mat-stroked-button>
                <mat-icon aria-hidden="false">close</mat-icon>
                Close
            </button>&nbsp;
            <button (click)="resetGrid()" mat-stroked-button color="accent">
                <mat-icon aria-hidden="false">refresh</mat-icon>
                Reset
            </button>
        </div>
    </mat-drawer>

    <mat-drawer-content style="padding-top: 15px">
        <h5 class="card-title text-muted">Journal Entries</h5>
        <mat-divider></mat-divider>

        <div class="row padding-top-10">
            <div class="col col-lg-2">
                <mat-form-field style="width: 100%">
                    <mat-label>Date From</mat-label>
                    <input matInput [formControl]="fromDate" [matDatepicker]="fromDateId" (ngModelChange)="updateFilter()">
                    <mat-datepicker-toggle *ngIf="fromDate.value != null" matSuffix (click)="fromDate.setValue(null)">
                        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle matSuffix [for]="fromDateId"></mat-datepicker-toggle>
                    <mat-datepicker #fromDateId></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col col-lg-2">
                <mat-form-field style="width: 100%">
                    <mat-label>Date To</mat-label>
                    <input matInput [formControl]="toDate" [matDatepicker]="toDateId" (ngModelChange)="updateFilter()">
                    <mat-datepicker-toggle *ngIf="toDate.value != null" matSuffix (click)="toDate.setValue(null)">
                        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle matSuffix [for]="toDateId"></mat-datepicker-toggle>
                    <mat-datepicker #toDateId></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col col-lg-2">
                <mat-checkbox style="padding-top: 15px" [(ngModel)]="includeDeleted"
                              (change)="reset()">
                    Include archived
                </mat-checkbox>
            </div>
            <div class="col col-lg-2">
                <button mat-icon-button color="primary" (click)="drawer.toggle()" class="margin-top-10">
                    <mat-icon aria-hidden="false">tune</mat-icon>
                    <span *ngIf="calculateActiveFiltersCount() > 0"
                          class="badge badge-small">{{calculateActiveFiltersCount()}}</span>
                </button>
            </div>
        </div>
        <mat-divider></mat-divider>

        <div class="table-container">
            <div class="table-loading-shade"
                 *ngIf="isLoadingResults">
                <mat-spinner [diameter]="50" *ngIf="isLoadingResults"></mat-spinner>
            </div>

            <div class="table-box">
                <table mat-table [dataSource]="data"
                       matSort matSortActive="createdAt" matSortDisableClear matSortDirection="desc">

                    <ng-container matColumnDef="location" sticky>
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
                        <td mat-cell *matCellDef="let row">{{row.location}}</td>
                    </ng-container>

                    <ng-container matColumnDef="transactionDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                        <td mat-cell *matCellDef="let row">{{row.transactionDate | date:'MM-dd-yyyy':'UTC'}}</td>
                    </ng-container>

                    <ng-container matColumnDef="externalId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>External Id</th>
                        <td mat-cell *matCellDef="let row">{{row.externalId}}</td>
                    </ng-container>

                    <ng-container matColumnDef="originalId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Internal Id</th>
                        <td mat-cell *matCellDef="let row">
                            <a *ngIf="row.netsuiteUrl" [href]="row.netsuiteUrl" target="_blank">{{row.internalId}}
                                <i class="bi bi-box-arrow-up-right"></i>
                            </a>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
                        <td mat-cell *matCellDef="let row">{{row.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                        <td mat-cell *matCellDef="let row" [matTooltip]="row.errorMessage">
                            <span [ngClass]="row.status == 'ERROR_POSTING' ? 'red-notice cursor-default' : (row.status == 'POSTED' ? 'green-notice' : '')">{{row.status}}</span>
                            <mat-icon *ngIf="row.status == 'ERROR_POSTING'" class="font-18">help_outline</mat-icon>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </div>

            <mat-paginator [length]="resultsLength" [pageSize]="pageSize"
                           [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>

    </mat-drawer-content>
</mat-drawer-container>
